import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import "../css/subjectAllocation.css";

import SubjectAllocationTable from "./subjectAllocationTbl.js";
import SubjectAllocationSlider from "./subjectAllocationSlider.js";


const SubjectTeacherAllocationCtrl = (props) => {
    const { filters, setFilters,loader, setLoader, opacity, setOpacity, lstSubjectAllocation, syllabusId, lstSubId, handleSelectChange, updateKey } = props;
    const [subjectAllocationId, setSubjectAllocationId] = useState(0);
    const [subjectAllocation, setSubjectAllocation] = useState({});
    const [isSubjectAllocationVisible, setIsSubjectAllocationVisible] = useState(false);



    const editSubjectAllocation = async (pSubjectAllocation) => {
        // console.log("editSubjectAllocation called, pSubjectAllocation ", pSubjectAllocation);
        await setSubjectAllocation(pSubjectAllocation);
        await setSubjectAllocationId(pSubjectAllocation.subId);
        setIsSubjectAllocationVisible(true);
    };

    const deleteSubjectAllocation = (pSubjectAllocationId) => {
        // console.log("deleteSubjectAllocation called, pSubjectAllocationId ", pSubjectAllocationId);
    };

    const closeSlider = () => {
        setIsSubjectAllocationVisible(false);
    };

    return (
        <div className="col-md-12 col-xs-12 col-centered padding-remove">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-centered padding-remove" style={{ marginTop: "45px" }}>
                <SubjectAllocationTable
                    lstSubjectAllocation={lstSubjectAllocation}
                    subjectAllocationId={subjectAllocationId}
                    setSubjectAllocationId={setSubjectAllocationId}
                    editSubjectAllocation={editSubjectAllocation}
                    deleteSubjectAllocation={deleteSubjectAllocation}
                    lstSubId={lstSubId}
                    handleSelectChange={handleSelectChange}
                />
            </div>
            {
                isSubjectAllocationVisible ?
                    (
                        <div className="slider1-80" >
                            <SubjectAllocationSlider
                                key={subjectAllocationId}
                                subject={subjectAllocation}
                                syllabusId={syllabusId}
                                updateKey={updateKey}
                                deleteSubjectAllocation={deleteSubjectAllocation}
                                closeSlider={closeSlider}
                            />
                        </div>
                    )
                    : null
            }
        </div >
    );
};

export default SubjectTeacherAllocationCtrl;
